import { useEffect, useState } from "react";

// D1 · true en escritorio (≥ 1280 px): resultados | ficha | cola en una sola vista.
export function useWideLayout(query = "(min-width: 1280px)") {
  const [wide, setWide] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setWide(mq.matches);
    mq.addEventListener("change", on);
    return () => { mq.removeEventListener("change", on); };
  }, [query]);
  return wide;
}
